import * as Yup from 'yup';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import LoadingButton from '@mui/lab/LoadingButton';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import HttpService from '../../../hooks/Https-services';
import { API_ROUTES } from '../../../utils/constant';
import { RHFTextField } from '../../../components/hook-form';
import { toast } from 'react-toastify';

// ----------------------------------------------------------------------

type Props = {
  open: boolean;
  onClose: VoidFunction;
  currentUser?: any;
};

export default function UserQuickEditForm({
  currentUser,
  open,
  onClose,
}: Props) {
  const NewUserSchema = Yup.object().shape({
    password: Yup.string().required('password is required'),
  });

  const methods = useForm({
    resolver: yupResolver(NewUserSchema),
  });

  const {
    reset,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = handleSubmit(async (data) => {
    const info = {
      userId: currentUser.id,
      password: data.password,
    };
    try {
      await HttpService.patch(API_ROUTES.resetPassword, info);
      reset();
      onClose();
      //   enqueueSnackbar('Update success!');
      toast.success('Update Password Successfully', {
        position: 'bottom-right',
      });
    } catch (error: any) {
      console.log(error);
    }
  });

  return (
    <Dialog
      fullWidth
      maxWidth={false}
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { maxWidth: 720 },
      }}
    >
      <FormProvider {...methods}>
        <form onSubmit={onSubmit}>
          <DialogTitle>Reset Password</DialogTitle>

          <DialogContent>
            <Box
              rowGap={3}
              columnGap={2}
              display="grid"
              gridTemplateColumns={{
                xs: 'repeat(1, 1fr)',
                sm: 'repeat(2, 1fr)',
              }}
              sx={{ marginTop: '10px' }}
            >
              <RHFTextField name="password" label="Password" />
            </Box>
          </DialogContent>

          <DialogActions>
            <Button
              variant="outlined"
              onClick={onClose}
              sx={{ whiteSpace: 'nowrap' }}
            >
              Cancel
            </Button>

            <LoadingButton
              type="submit"
              variant="contained"
              loading={isSubmitting}
            >
              Update
            </LoadingButton>
          </DialogActions>
        </form>
      </FormProvider>
    </Dialog>
  );
}
